import { Plugin } from '@nuxt/types'
import s from '~/utils/s'

const auth: Plugin = async ({ store }) => {
  const sfToken = s(store).auth._sfToken

  if (sfToken) store.$api.setSfToken(sfToken)
  else await s(store).auth.fillAuthorizeToken()

  const refreshToken = s(store).auth.refreshToken

  if (refreshToken) store.$api.setRefreshToken(refreshToken)
}

export default auth
